import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  headerDetails: [],
  data: null,
  countryData: null,
  globalSearchPreData: null,
  isLoading: false,
  error: false,
  miniProfileSelected: false,
  dataGovn: null,
  isLoadingGovn: false,
  errorGovn: false,
  dataCorporate: null,
  isLoadingCorporate: false,
  errorCorporate: false,
  dataAgency: null,
  isLoadingAgency: false,
  errorAgency: false
};
const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    headerDataRequest: state => {
      state.isLoading = true;
      state.error = null;
    },
    getHeaderDataSuccess: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    getHeaderDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    getGovnHeaderDataSuccess: (state, action) => {
      state.dataGovn = action.payload;
      state.isLoadingGovn = false;
    },
    getGovnHeaderDataFailure: (state, action) => {
      state.errorGovn = action.payload;
      state.isLoadingGovn = false;
    },
    corporateHeaderDataRequest: state => {
      state.isLoadingCorporate = true;
      state.errorCorporate = null;
    },
    getCorporateHeaderDataSuccess: (state, action) => {
      state.dataCorporate = action.payload;
      state.isLoadingCorporate = false;
    },
    getCorporateHeaderDataFailure: (state, action) => {
      state.errorCorporate = action.payload;
      state.isLoadingCorporate = false;
    },
    agencyHeaderDataRequest: state => {
      state.isLoadingAgency = true;
      state.errorAgency = null;
    },
    getAgencyHeaderDataSuccess: (state, action) => {
      state.dataAgency = action.payload;
      state.isLoadingAgency = false;
    },
    getAgencyHeaderDataFailure: (state, action) => {
      state.errorAgency = action.payload;
      state.isLoadingAgency = false;
    },
    globalSearchPreRenderDataRequest: state => {
      state.isLoading = true;
      state.error = null;
    },
    globalSearchPreRenderDataSuccess: (state, action) => {
      state.globalSearchPreData = action.payload;
      state.isLoading = false;
    },
    globalSearchPreRenderDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    updateMiniProfileSelected: (state, action) => {
      if (action.payload === undefined) {
        state.miniProfileSelected = !state.miniProfileSelected;
      } else {
        state.miniProfileSelected = action.payload;
      }
    }
  }
});
export const {
  headerDataRequest,
  getHeaderDataSuccess,
  getHeaderDataFailure,
  globalSearchPreRenderDataRequest,
  globalSearchPreRenderDataSuccess,
  globalSearchPreRenderDataFailure,
  updateMiniProfileSelected,
  getGovnHeaderDataFailure,
  getGovnHeaderDataSuccess,
  corporateHeaderDataRequest,
  getCorporateHeaderDataSuccess,
  getCorporateHeaderDataFailure,
  agencyHeaderDataRequest,
  getAgencyHeaderDataSuccess,
  getAgencyHeaderDataFailure
} = HeaderSlice.actions;
export default HeaderSlice.reducer;